import { toast } from "react-toastify";
import Web3 from "web3";
import { routerabi, tokenabi } from "./abi";
import { Suspense, useEffect, useState } from "react";
import Lodable from "../loader/Lodable";
import CryptoJS from "crypto-js";
import { frontend_url_ref } from "../../aZxPqR";
import moment from "moment-timezone";
import { BrowserProvider, Contract, formatUnits, parseUnits } from "ethers";


export const copyCode = async (data, msg = "Text") => {
  if (!data) {
    toast.error("Nothing to copy");
    return;
  }

  // Modern Clipboard API
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(data);
      toast.success(`${msg} copied!`);
    } catch (error) {
      fallbackCopy(data, msg);
    }
  } else {
    // Fallback for HTTP / old browsers
    fallbackCopy(data, msg);
  }
};

const fallbackCopy = (text, msg) => {
  try {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    textArea.style.position = "fixed"; // avoid scroll
    textArea.style.opacity = "0";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    const successful = document.execCommand("copy");
    document.body.removeChild(textArea);

    if (successful) {
      toast.success(`${msg} copied!`);
    } else {
      toast.error("Copy failed");
    }
  } catch (err) {
    toast.error("Copy not supported");
  }
};

export const approvetokens = async (
  amount,
  tokenaddress,
  routeraddress,
  chainId,
  walletProvider,
  address,
  callback,
) => {
  try {
    if (!amount || !tokenaddress || !routeraddress) {
      const findval = !amount
        ? "amount"
        : !tokenaddress
          ? "tokenadress"
          : "routeraddress";
      return callback({ status: false, message: `${findval} not found` });
    } else {
      if (!walletProvider || !address) throw Error("user is disconnected");
      const account = address;

      const provider = new BrowserProvider(walletProvider, chainId);
      const signer = await provider.getSigner();

      const tokenContract = new Contract(tokenaddress, tokenabi, signer);

      // 🔹 get decimals
      const decimals = await tokenContract.decimals();

      // 🔹 get allowance
      const allowanceRaw = await tokenContract.allowance(
        account,
        routeraddress,
      );
      const convertAllowance = formatUnits(allowanceRaw, decimals);

      // if (Number(convertAllowance) > Number(amount)) {
      //   return callback({
      //     status: true,
      //     message: "success",
      //     allowance: convertAllowance,
      //   });
      // } else {
        // approve amount (example: unlimited or required amount)
        const approveAmount = parseUnits(amount.toString(), decimals);
        // or better: parseUnits(amount, decimals)

        // 🔹 estimate gas
        const estimatedGas = await tokenContract.approve.estimateGas(
          routeraddress,
          approveAmount,
        );


        // 🔹 send approve tx
        const tx = await tokenContract.approve(routeraddress, approveAmount, {
          gasLimit: estimatedGas,
        });

        const receipt = await tx.wait();

        if (!receipt || receipt.status !== 1) {
          return callback({
            status: false,
            message: "receipt not created",
          });
        } else {
          return callback({
            status: true,
            message: "receipt created",
            hash: receipt.hash,
          });
        }
      // }
    }
  } catch (e) {
    return callback({ status: false, message: e.message });
  }
};

export const deposits = async (
  useramount,
  tokenaddress,
  routeraddress,
  walletProvider,
  callback,
) => {
  try {
    if (!useramount || !tokenaddress || !routeraddress) {
      const findval = !useramount
        ? "amount"
        : !tokenaddress
          ? "tokenaddress"
          : "routeraddress";
      return callback({ status: false, message: `${findval} not found` });
    }

    if (!walletProvider) {
      return callback({ status: false, message: "Wallet not connected" });
    }

    //  Provider & signer from AppKit
    const provider = new BrowserProvider(walletProvider);
    const signer = await provider.getSigner();
    const userAddress = await signer.getAddress();

    // ERC20 contract
    const tokenContract = new Contract(tokenaddress, tokenabi, signer);

    //  Router contract
    const routerContract = new Contract(routeraddress, routerabi, signer);

    // Read decimals safely
    const decimals = await tokenContract.decimals();

    //  Convert amount properly
    const amount = parseUnits(useramount.toString(), decimals);

    // //  APPROVE FIRST
    // const approveTx = await tokenContract.approve(routeraddress, amount);
    // await approveTx.wait();

    //  Deposit
    const tx = await routerContract.deposit(tokenaddress, amount);
    const receipt = await tx.wait();

    return callback({
      status: true,
      message: "Deposit successful",
      hash: receipt.hash,
    });
  } catch (e) {
    return callback({ status: false, message: e.message });
  }
};

export const getCoinBalance = async (address) => {
  if (!window.ethereum) throw new Error("MetaMask not found");
  const web3 = new Web3(window.ethereum);
  const [account] = await window.ethereum.request({
    method: "eth_requestAccounts",
  });
  // balance in wei
  const balanceWei = await web3.eth.getBalance(account);
  // convert to coin (18 decimals)
  const balance = web3.utils.fromWei(balanceWei, "ether");
  return balance; // string
};

export const getTokenBalance = async (tokenAddress, address) => {
  const web3 = new Web3(window.ethereum);
  const tokenContract = new web3.eth.Contract(tokenabi, tokenAddress);
  // raw balance
  const balanceRaw = await tokenContract.methods.balanceOf(address).call();

  // token decimals
  const decimals = await tokenContract.methods.decimals().call();

  // convert to human readable
  const balance =
    Number(decimals) == 18 ? web3.utils.fromWei(balanceRaw, "ether") : 0;

  return balance; // number
};

export default function useDebounce(value, delay = 1000) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}

export const OtpTimer = ({ createdAt }) => {
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (!createdAt) return;

    const interval = setInterval(() => {
      const now = Date.now(); // current time (ms)

      const timestampMs = new Date(createdAt).getTime();

      const diffSeconds = Math.max(Math.floor((timestampMs - now) / 1000), 0);

      setTimeLeft(diffSeconds);

      if (diffSeconds === 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [createdAt]);

  // 🔥 convert seconds → mm.ss
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  if (timeLeft == 0) {
    localStorage.setItem("timestatus", "true");
  }

  return (
    <div>
      {timeLeft > 0 ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "13px",
            color: "#555",
          }}
        >
          <span>OTP expires in</span>

          <div
            style={{
              background: "#111",
              color: "#fff",
              padding: "4px 8px",
              borderRadius: "4px",
              fontWeight: "600",
              letterSpacing: "1px",
            }}
          >
            {minutes}:{seconds.toString().padStart(2, "0")}
          </div>
        </div>
      ) : timeLeft == 0 ? (
        <span style={{ color: "red" }}>OTP Expired</span>
      ) : (
        ""
      )}
    </div>
  );
};

// components/PageLoader.jsx

export const Load = (Component) => (props) => (
  <Suspense fallback={<Lodable />}>
    <Component {...props} />
  </Suspense>
);

export const toFixedDecimal = (value, decimals = 2) => {
  if (value === null || value === undefined || value === "" || value == 0 || value == '0') return 0
  return Number(value)?.toFixed(decimals);
};

export const withdrawfeecalc = (amount, fee,toast) => {
  if(amount <= 0) return toast.error("Amount must be greater than 0");
  const fees = (Number(amount) * Number(fee)) / 100;
  return toFixedDecimal(fees, 4);
};

export const getPageNumbers = (current, total) => {
  const pages = new Set();

  // First 3
  for (let i = 1; i <= 2 && i <= total; i++) {
    pages.add(i);
  }

  // Middle 5 (current page centered)
  const start = Math.max(current - 2, 1);
  const end = Math.min(current + 2, total);
  for (let i = start; i <= end; i++) {
    pages.add(i);
  }

  // Last 3
  for (let i = total - 2; i <= total; i++) {
    if (i > 0) pages.add(i);
  }

  return [...pages].sort((a, b) => a - b);
};

export const shortHash = (hash, f, l) => {
  if (!hash || typeof hash !== "string") return "";

  if (hash.length <= 10) return hash; // already short

  return `${hash.slice(0, f || 6)}...${hash.slice(`-${l || 4}`)}`;
};

// 🔐 Encrypt
export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    frontend_url_ref,
  ).toString();
};

// 🔓 Decrypt
export const decryptData = (cipherText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, frontend_url_ref);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  } catch (err) {
    return null;
  }
};

export const datetime = (backendTime) => {
  // user browser timezone
  const userTimeZone = moment.tz.guess();
  let localTime = "";
  if (userTimeZone) {
    localTime = moment
      .utc(backendTime)
      .tz(userTimeZone)
      .format("DD/MM/YYYY hh:mm A");
  } else {
    localTime = moment(backendTime, "YYYY-MM-DD HH:mm:ss")?.format(
      "DD MMM YYYY, hh:mm A",
    );
  }
  return localTime;
};



const SECRET_KEY = 'zVVmpUFsiAAKiEjPwUGC';

export const encryptDatapayload = (data) => {
  if (!data) return data;

  const jsonString = JSON.stringify(data);

  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(jsonString), SECRET_KEY).toString();

  return encrypted;
};




export const decryptDatapayload = (data) => {
  try {
      if (!data) return data;
  const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    return JSON.parse(decrypted);
  } catch (error) {
    console.error("Decrypt parse error:", error);
    return {};
  }
};
